<section class="cz-password-login" *ngIf="language$ | async as language">
  <header class="header">
    <div class="container-fluid">
      <div class="row middle-xs">
        <div class="col-xs-8">
          <div class="row middle-xs">
            <div class="col-xs-3">
              <img src="/assets/images/global/Comfort-Zone-Logo.png" alt="Comfort Zone" />
            </div>
            <div class="col-xs-9">
              <h1 class="no-margin h3 tag" [innerHTML]="'$login_tagline' | translate"></h1>
            </div>
          </div>
        </div>
        <div class="col-xs-4 end-xs partner-logo-container" *ngIf="logoHref && logoHref.length > 1">
          <img class="partner-logo" src="{{logoHref}}" alt="Partner logo" />
        </div>
      </div>
    </div>
  </header>

  <mat-card class="login-card">
    <mat-toolbar color="primary">
      <mat-toolbar-row>
        <div class="col-xs-10">
          <h2 [ngClass]="{'title-custome':('$login_card_password_reset_label' | translate).length>=29}"
            [innerHTML]="'$login_card_password_reset_label' | translate"></h2>
        </div>
       
         
      </mat-toolbar-row>
    </mat-toolbar>
    <mat-card-content>
      <!-- Initial password reset form -->
      <div *ngIf="displayPasswordResetForm">
        <form [formGroup]="passwordResetGroup">
          <div class="row">
            <div class="col-xs-12">
              <mat-form-field class="form-field form-full-width-field">
                <mat-label [innerHTML]="'$login_card_password_reset_password_input_label' | translate"></mat-label>
                <input matInput [type]="hidePassword1 ? 'password' : 'text'" [formControl]="password1" required>
                <mat-icon matSuffix (click)="hidePassword1 = !hidePassword1">{{hidePassword1 ? 'visibility' :
                  'visibility_off'}}</mat-icon>
                <!-- *ngIf="password1.invalid && password1.errors.notStrong" -->
                <mat-error [innerHTML]="'$login_card_password_reset_password_complexity_input_error' | translate">
                </mat-error>
                <mat-error *ngIf="password1.invalid" [innerHTML]="'$login_card_password_input_error' | translate">
                </mat-error>
              </mat-form-field>
              <mat-form-field class="form-field form-full-width-field">
                <mat-label [innerHTML]="'$login_card_password_reset_confirm_password_input_label' | translate">
                </mat-label>
                <input matInput [type]="hidePassword2 ? 'password' : 'text'" [formControl]="password2" required>
                <mat-icon matSuffix (click)="hidePassword2 = !hidePassword2">{{hidePassword2 ? 'visibility' :
                  'visibility_off'}}</mat-icon>
                <!-- <mat-error *ngIf="password2.invalid && password2.errors.noMatch"
                  [innerHTML]="'$login_card_password_reset_password_no_match_input_error' | translate"></mat-error> -->
              </mat-form-field>
            </div>
          </div>
          <mat-error class="bg-r" *ngIf="isSamePassword" style="font-size: small;"
            [innerHTML]="'$login_card_password_reset_password_no_match_input_error' | translate"></mat-error>
          <div style="display: inline;">
            <mat-error class="bg-r" style="display: inline;" *ngIf="isPasswordLength"
              [innerHTML]="'$password_requirement_min_length' | translate"></mat-error><span class="bg-r"
              *ngIf="isPasswordLength">:{{passwordSiteSettingsInfo.minimumLength}}</span>
          </div>
          <div style="display: inline">
            <mat-error style="display: inline;" *ngIf="isUniquePasswordError"
              [innerHTML]="'$password_requirement_unique_req' | translate"></mat-error> <span class="bg-r"
              *ngIf="isUniquePasswordError">:{{uniquePassword}}</span>
          </div>
          <div style="display: inline">
            <mat-error style="display: inline;" *ngIf="isPasswordCharactersReseted"
              [innerHTML]="'$password_requirement_char_change' | translate"></mat-error> <span class="bg-r"
              *ngIf="isPasswordCharactersReseted">:{{passwordCharacterResetMessage}} %</span>
          </div>
          <div style="margin-top: 10px;">
            <p style="margin-top: 0" [innerHTML]="'$password_requirement_desc' | translate"></p>
            <ul class="pswd-buttet-points">
              <li class="pswd-rules" style="list-style-type:square"
                *ngIf="passwordSiteSettingsInfo.requiredCharacterSets.includes('a-z')" style="list-style-type:square">
                 <span [innerHTML]="'$password_requirement_char_lower' | translate"></span></li>
              <li *ngIf="passwordSiteSettingsInfo.requiredCharacterSets.includes('A-Z')" class="pswd-rules" style="list-style-type:square"><span
                  [innerHTML]="'$password_requirement_char_capital' | translate"></span></li>
              <li *ngIf="passwordSiteSettingsInfo.requiredCharacterSets.includes('0-9')" class="pswd-rules" style="list-style-type:square"><span
                  [innerHTML]="'$password_requirement_char_number' | translate"></span></li>
              <li  *ngIf="passwordSiteSettingsInfo.requiredCharacterSets.includes('special')" class="pswd-rules" style="list-style-type:square"><span
                  [innerHTML]="'$password_requirement_char_special' | translate"></span></li>
              <li *ngIf="passwordSiteSettingsInfo.minimumLength>0" class="pswd-rules" style="list-style-type:square"> <span [innerHTML]="'$site_setting_password_min_length' | translate">
                  </span>: {{passwordSiteSettingsInfo.minimumLength}}
              </li>
              <li *ngIf="passwordSiteSettingsInfo.minimumDaysForPasswordAge>0" class="pswd-rules" style="list-style-type:square"><span
                  [innerHTML]="'$password_requirement_min_age' | translate"></span>{{passwordSiteSettingsInfo.minimumDaysForPasswordAge}}
                Days </li>
              <li *ngIf="passwordSiteSettingsInfo.noOfUniquePasswordsBeforeReuse>0" class="pswd-rules" style="list-style-type:square"><span
                  [innerHTML]="'$password_requirement_unique_req' | translate"></span>{{passwordSiteSettingsInfo.noOfUniquePasswordsBeforeReuse}}
                Passwords</li>
              <li *ngIf="passwordSiteSettingsInfo.minimumCharactersChangeInNewPassword>0" class="pswd-rules" style="list-style-type:square"><span
                  [innerHTML]="'$password_requirement_char_change' | translate"></span>{{passwordSiteSettingsInfo.minimumCharactersChangeInNewPassword}}
              </li>
            </ul>
          </div>
          <!-- <div class="row">
            <p class="text-center text-danger"
              [innerHTML]="'$login_card_password_reset_password_complexity_input_error_desc' | translate"></p>
          </div> -->
          <div class="row bottom-buttons mtop-2">
            <div class="col-xs-7 end-xs">
            </div>
            <div class="col-xs-6 pl-0">
              <button align="right" mat-stroked-button color="accent" (click)="onNoClick()"
                *ngIf="fromAdminResetPassword && passwordResetByAdmin"
                [innerHTML]="'$lng_calcel_but' | translate"></button>

              <button align="right" mat-stroked-button color="accent" (click)="logout()"
                *ngIf="fromAdminResetPassword && !passwordResetByAdmin"
                [innerHTML]="'$lng_calcel_but' | translate"></button>
              <button *ngIf="!fromAdminResetPassword" mat-button color="accent" (click)="goToLogin()"
                [innerHTML]="'$login_card_return_to_login' | translate"></button>
            </div>
            <div class="col-xs-6 end-xs">
              <button mat-flat-button color="accent" (click)="updatePassword()"
                [innerHTML]="'$login_card_password_reset_btn_submit' | translate"></button>
            </div>
          </div>

        </form>
      </div>

      <!-- Password reset success -->
      <div *ngIf="displayPasswordSuccess">
        <div class="row center-xs">
          <div class="col">
            <h5 class="question-label" [innerHTML]="'$login_card_password_reset_confirm_message' | translate"></h5>
          </div>
        </div>
        <div class="row action-buttons center-xs">
          <div class="col">
            <button mat-flat-button color="accent" (click)="goToLogin()"
              [innerHTML]="'$login_card_return_to_login' | translate"></button>
          </div>
        </div>
      </div>

      <!-- Password token expired -->
      <div *ngIf="displayPasswordTokenExpired">
        <div class="row center-xs">
          <div class="col">
            <h5 class="question-label error" [innerHTML]="'$login_card_password_reset_expired' | translate"></h5>
          </div>
        </div>
        <div class="row action-buttons center-xs">
          <div class="col">
            <button mat-flat-button color="accent" (click)="goToResetPassword()"
              [innerHTML]="'$login_card_return_to_forgot_password' | translate"></button>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>


  <footer class="footer" *ngIf="!fromAdminResetPassword">
    <p></p>
  </footer>
</section>